import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "badge text-bg-warning me-1"
}
const _hoisted_17 = {
  key: 1,
  class: "badge text-bg-secondary me-1"
}

import { ref, onMounted } from "vue";
import { TopicTypes } from "@/core/types/TopicTypes";
import GlobalService from "../../../services/TenantGlobalService";
import EmailDetail from "../components/EmailDetail.vue";
import CreateEmailTemplate from "../components/CreateEmailTemplate.vue";
import EmailTemplateDetail from "../components/EmailTemplateDetail.vue";
import { LanguageCodes, LanguageTypes } from "@/core/types/LanguageTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'EmailTemplate',
  setup(__props) {

const CreateEmailTemplateRef = ref<InstanceType<typeof CreateEmailTemplate>>();

const emailDetailRef = ref<any>(null);
const emailDetailRefTwo = ref<any>(null);
const isLoading = ref(false);
const emailList = ref(Array<any>());

const defaultLayout = ref(null);

onMounted(async () => {
  fetchData();
});

const fetchData = async () => {
  isLoading.value = true;
  emailList.value = [];
  emailList.value = (
    await GlobalService.queryEventTopics({
      type: TopicTypes.Email,
      size: 100,
    })
  ).data;
  emailList.value.forEach((item) => {
    const sortedContent: { [key: string]: any } = {};
    const keys = Object.keys(item.contents).sort();

    keys.forEach((key) => {
      sortedContent[key] = item.contents[key];
    });

    item.contents = sortedContent;
  });

  defaultLayout.value = emailList.value.filter(
    (item) => item.title == "DefaultLayout"
  )[0];

  isLoading.value = false;
};

const showEmailDetail = (detail) => {
  emailDetailRef.value.show(detail, defaultLayout.value);
};

const detail = (item) => {
  emailDetailRefTwo.value.show(item, defaultLayout.value);
};

const onCreateSubmitted = () => {
  fetchData();
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.emailTemplate")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (CreateEmailTemplateRef.value?.show()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.new")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.key")), 1),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.language")), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.updated_at")), 1),
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("action.action")), 1)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && emailList.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emailList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageTypes).all, (i, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (i.code in item.contents)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(i.code), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(i.code), 1))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TimeShow, {
                        type: "inFields",
                        "date-iso-string": item.createdOn
                      }, null, 8, ["date-iso-string"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        onClick: ($event: any) => (detail(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("title.details")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(EmailDetail, {
      ref_key: "emailDetailRef",
      ref: emailDetailRef,
      onEventSubmit: onCreateSubmitted
    }, null, 512),
    _createVNode(CreateEmailTemplate, {
      ref_key: "CreateEmailTemplateRef",
      ref: CreateEmailTemplateRef,
      onEventSubmit: onCreateSubmitted
    }, null, 512),
    _createVNode(EmailTemplateDetail, {
      ref_key: "emailDetailRefTwo",
      ref: emailDetailRefTwo,
      onEventSubmit: onCreateSubmitted
    }, null, 512)
  ]))
}
}

})